import { Schema, get } from '../../../json-transform';
import { baseGeneralEvent } from './baseGeneralEvent';

export const generalEventToEvent = (client) => new Schema({
  ...baseGeneralEvent(client),
  create_time: get('event_create_time'),
  end_time: get('event_end_time'),
});
